<template>
  <div class="member__bank">
    <div class="title">题库权益</div>
    <div class="member__banks" @click="goStudy">
      <div class="bank__icon"></div>
      <div class="member__bank-item item1"><span class="dot"></span>智能组卷：自动生成试卷，随时检测学习效果</div>
      <div class="member__bank-item item2"><span class="dot"></span>知识点练习：个性化针对性训练，定向提升</div>
      <div class="member__bank-item item3"><span class="dot"></span>深度试题解析：详细解析推导过程、解题思路和技巧等</div>
    </div>

  </div>
</template>

<script>
import { whatEev } from '@/utils/tools';
import wx from 'weixin-js-sdk';

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    goStudy() {
      if (whatEev() === 'miniprogram') {
        wx.miniProgram.switchTab({
          url: '/pages/questions/questions',
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('goToTkPage', 0, false);
      } else {
        const path = `${window.location.origin}/question/`;
        window.location.href = path;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../index.scss';

.member__bank {
  width: 678px;
  border-radius: 14px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto 36px;
}

.title {
  width: 100%;
  margin-bottom: 22px;
  height: 40px;
  font-size: 29px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 40px;
}

.member__banks {
  padding: 21px 29px;
  background: #fff;
  width: 100%;
  position: relative;
  border-radius: 14px;
}

.bank__icon {
  @include background(72px, 72px);
  @include backgroundImage('member_bank1.png');
  position: absolute;
  top: 60px;
  right: 29px;
}

.member__bank-item {
  font-size: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 48px;
}

.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #FF7F41;
  border-radius: 50%;
  position: relative;
  top: -2px;
  margin-right: 7px;
}</style>
